module.exports = __webpack_public_path__ + "static/media/fvs_salaMendoza_13.75ba7ec5.jpg";